import numOrDefault from 'lib/helpers/numOrDefault';
import { formatDate, mString } from 'lib/helpers/utility';

import InvoiceActionPopover from 'components/practice/charts/billing/Invoices/components/InvoiceActionPopover';
import {
  APPOINTMENT_RESOURCE_OPTIONS,
  PROVIDER_OPTIONS,
  TAG_INVOICE_OPTIONS
} from 'components/shared/Filters/lib/filterOptions';
import TagsCell from 'components/shared/Tags/components/Cell/TagsCell';

export const getColDefs = (timezone) => [
  { headerName: 'ID', field: 'id', headerCheckboxSelection: true, checkboxSelection: true },
  {
    field: 'provider',
    headerName: 'Provider'
  },
  {
    headerName: 'Pt. Charge',
    valueFormatter: ({ value }) => mString(numOrDefault(value)),
    aggFunc: 'sum',
    field: 'total_amount',
    width: 160
  },
  {
    headerName: 'Tax',
    valueFormatter: ({ value }) => mString(numOrDefault(value)),
    aggFunc: 'sum',
    field: 'tax',
    width: 150
  },
  {
    headerName: 'Total Charge',
    valueFormatter: ({ value }) => mString(numOrDefault(value)),
    valueGetter: ({ data }) => numOrDefault(data?.total_amount) + numOrDefault(data?.tax),
    aggFunc: 'sum',
    field: 'total_charge',
    width: 150
  },
  {
    headerName: 'Amount Paid',
    valueFormatter: ({ value }) => mString(numOrDefault(value)),
    aggFunc: 'sum',
    field: 'amount_paid',
    width: 150
  },
  {
    headerName: 'Write-Off',
    valueFormatter: ({ value }) => mString(numOrDefault(value)),
    aggFunc: 'sum',
    field: 'write_off',
    width: 150
  },
  {
    headerName: 'Discount',
    valueFormatter: ({ value }) => mString(numOrDefault(value)),
    aggFunc: 'sum',
    field: 'discountAmount',
    width: 150
  },
  {
    headerName: 'Balance',
    valueFormatter: ({ value }) => mString(numOrDefault(value)),
    aggFunc: 'sum',
    field: 'balance',
    width: 150
  },
  {
    headerName: 'Date of Service',
    field: 'dateofservice',
    valueGetter: (params) => {
      if (!!params?.node?.group) {
        return '';
      }
      const dos = params?.data?.dateofservice;
      return formatDate(dos, timezone, true);
    }
  },
  {
    field: 'tagLinks',
    headerName: 'Tags',
    cellClass: 'no-border',
    minWidth: 300,
    cellRenderer: ({ value, data }) => (
      <TagsCell
        value={value}
        kind="invoice"
        data={data}
        query={{
          keys: ['patientInvoices', 'invoice-tags'],
          object: 'patientInvoices',
          multiple: true
        }}
        refTable="invoice"
      />
    ),
    pinned: 'right',
    sortable: false
  },
  {
    field: 'actions',
    headerName: 'Actions',
    cellRenderer: InvoiceActionPopover,
    maxWidth: 88,
    minWidth: 36,
    resizable: false,
    sortable: false,
    pinned: 'right'
  }
];

export const DEFAULT_COLUMN_DEFS = { resizable: true, enableRowGroup: true };

export const GRID_OPTIONS = {
  rowGroupPanelShow: 'always',
  animateRows: true,
  suppressAggFuncInHeader: true,
  enableRangeSelection: true,
  groupSelectsChildren: true
};

export const DEFAULT_FILTERS = {
  date: {
    type: 'date-range',
    title: 'Date of Service',
    icon: 'calendar-mono'
  },
  id: {
    title: 'ID',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'text-num-mono'
  },
  provider: PROVIDER_OPTIONS,
  appointment_resource: APPOINTMENT_RESOURCE_OPTIONS,
  invoiceTags: TAG_INVOICE_OPTIONS
};
